export default function DirectoryFaq({ items = [] }) {
  if (!items.length) return null;
  return (
    <section className="site-shell py-12 sm:py-16">
      <div className="soft-card p-5 sm:p-8">
        <h2 className="text-3xl font-black tracking-tight text-neutral-950">Frequently asked questions</h2>
        <div className="mt-6 grid gap-4 lg:grid-cols-2">
          {items.map((item) => (
            <article key={item.question} className="rounded-2xl border border-neutral-200 bg-neutral-50 p-5">
              <h3 className="text-lg font-black text-neutral-950">{item.question}</h3>
              <p className="mt-3 text-sm leading-7 text-neutral-600">{item.answer}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
